export default "/images/hexagon.svg?36c5ed9776ba20dc3aad969601cb7857";